abstract class BaseApiError extends Error {
  readonly type: string = ''
}

export default BaseApiError
